import React from 'react';

import { ArrowRightIcon } from 'lucide-react';

import { cn } from '../../../utils/cn.js';

export default function PortalBigButton({
  icon,
  title,
  description,
  onClick,
  className,
  arrow = true,
}) {
  return (
    <button
      onClick={() => onClick && onClick()}
      className={cn(
        'grid w-full grid-cols-6 items-center justify-between gap-8 rounded-[24px] bg-portal-primary px-8 py-4',
        className,
      )}
    >
      <div className="col-span-5 flex items-center gap-6">
        <div>{React.cloneElement(icon, { className: 'sm:size-6' })}</div>
        <div className="flex flex-col">
          <span className="text- text-left font-noto-ikea-bold font-bold">
            {title}
          </span>
          {description && (
            <span className="mt-1 text-left text-xs text-portal-destructive">
              {description}
            </span>
          )}
        </div>
      </div>
      {arrow && (
        <div className="flex h-full items-center justify-end">
          <div className="mr-2 min-h-16 w-[1px] bg-portal-text lg:mr-4"></div>
          <ArrowRightIcon className="size-6" />
        </div>
      )}
    </button>
  );
}
